const navbarInit = () => {
  const header: Element = document.querySelector('.header');
  const navigation: Element = document.querySelector('.navigation');

  if (navigation) {
    const navigationActive: string = 'navigation--active';
    const menuOpen: Element = document.querySelector('.toggler-open');
    const menuClose: Element = document.querySelector('.toggler-close');
    const toggler: Element = header.querySelector('.header__toggler');
    const togglerWrapper: Element = header.querySelector('.toggler-wrapper');
    const search: HTMLElement = document.querySelector('.header__search');
    const searchBar: HTMLElement = document.querySelector('.searchbar');
    const togglerActive: string = 'toggler--active';
    const { body } = document;
    let isOpen: boolean = false;

    togglerWrapper.addEventListener('click', () => {
      isOpen = !isOpen;
      if (isOpen) {
        menuOpen.classList.add('d-none');
        menuClose.classList.remove('d-none');
      } else {
        menuOpen.classList.remove('d-none');
        menuClose.classList.add('d-none');
      }
      search.classList.remove('header__search--active');
      searchBar.classList.add('d-none');
      body.classList.toggle('overflow-m-hidden');
      navigation.classList.toggle(navigationActive);
      toggler.classList.toggle(togglerActive);
    });
  }
};

export default navbarInit;
